import { render, staticRenderFns } from "./Inout.vue?vue&type=template&id=a95c87c6&scoped=true&"
import script from "./Inout.vue?vue&type=script&lang=js&"
export * from "./Inout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95c87c6",
  null
  
)

export default component.exports